import '.a{display:grid;}.ssr-plugin'
import '.b1{gap:2rem;}.ssr-plugin'
import { styled } from 'inlines'
import { ServiceProviderCard } from '@app/components/blocks/card/ServiceProviderCard'
import { ServiceProviderListRegionalModel } from 'functions/app/service-provider/list-regional'
import useMediaQuery from '@app/util/useMediaQuery'

export const RegionalServiceProvidersGrid = ({
  serviceProviders,
}: {
  serviceProviders: ServiceProviderListRegionalModel[]
}) => {
  const isMobile = useMediaQuery()
  return (
    <div className="a b1"
      style={{
        gridTemplateColumns: isMobile
          ? 'repeat(1, minmax(250px, 1fr))'
          : 'repeat(2, minmax(250px, 1fr))',}}
    >
      {serviceProviders.map((sp) => (
        <ServiceProviderCard
          key={sp.id}
          slug={sp.slug}
          name={sp.name}
          description={sp.description}
          banner={sp.banner}
          avatar={sp.avatar?.src}
          types={sp.type}
        />
      ))}
    </div>
  )
}
